import { useState, Fragment } from "react";

export const ViewAdjustmentDetailPublish = () => {
  const [isEdit, setIsEdit] = useState(false);
  return (
    <>
      <div className="content_wrap">
        <div className="fiter_top">
          <h3 className="filter_heading">조정 상세보기</h3>
          <div className="filter_toolbar">
            <button className="btn btn-outline-primary w-100px h-38px">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icon_hamburger_btn.png"
                }
                alt=""
              />
              목록
            </button>
            {isEdit == false && (
              <Fragment>
                <button
                  className="btn btn-secondary w-100px h-38px"
                  onClick={() => setIsEdit(true)}
                >
                  등록
                </button>
              </Fragment>
            )}
            {isEdit == true && (
              <Fragment>
                <button
                  className="btn btn-info w-100px h-38px"
                  onClick={() => setIsEdit(false)}
                >
                  저장
                </button>
                <button
                  className="btn btn-outline-secondary w-100px h-38px"
                  onClick={() => setIsEdit(false)}
                >
                  취소
                </button>
              </Fragment>
            )}
          </div>
        </div>
        <h5 className="subheading">조정 정보</h5>
        <table className="table table-bordered my_table">
          <tbody>
            <tr>
              <th style={{ width: "16.66%" }}>입고번호</th>
              <td colSpan={3}>1234</td>
            </tr>
            <tr>
              <th style={{ width: "16.66%" }}>생성자</th>
              <td style={{ width: "33.3%" }}>홍길동</td>
              <th style={{ width: "16.66%" }}>생성일자</th>
              <td>2024-05-05</td>
            </tr>
            <tr>
              <th>메모</th>
              <td colSpan={3}>5월 입고</td>
            </tr>
          </tbody>
        </table>
        <div className="table_top mb-10px align-items-end">
          <h6 className="table_stats">조정 품목</h6>
          <div className="table_toolbar">
            <button className="btn btn-outline-dark w-150px px-0">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"}
                alt=""
              />
              엑셀 가져오기
            </button>
            <button className="btn btn-primary w-100px px-0 ms-40px">
              바코드 스캔
            </button>
            <button className="btn btn-dark w-100px px-0">추가</button>
          </div>
        </div>

        <table className="table table-bordered my_table mb-0">
          <thead>
            <tr>
              <th style={{ width: "10.06%" }}>벤더</th>
              <th style={{ width: "10.06%" }}>카테고리</th>
              <th style={{ width: "33.33%" }}>품목</th>
              <th style={{ width: "13.83%" }}>규격</th>
              <th style={{ width: "13.83%" }}>단위</th>
              <th>현재재고</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">MS</td>
              <td className="text-center">CSP</td>
              <td>S1-WIN Pro-E7 SP1 32-64b</td>
              <td className="text-center">7WT-0001</td>
              <td className="text-center">50</td>
              <td className="p-4px">32 &gt; 8</td>
            </tr>
            <tr>
              <td className="text-center">MS</td>
              <td className="text-center">CSP</td>
              <td>S1-WIN Pro-E7 SP1 32-64b</td>
              <td className="text-center">7WT-0001</td>
              <td className="text-center">50</td>
              <td className="p-4px">32 &gt; 8</td>
            </tr>
            <tr className="blue">
              <td className="text-center" colSpan={3}>
                품목 수
              </td>
              <td className="text-end">2</td>
              <td className="text-center">총 수량</td>
              <td className="text-end">-2</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
